module.exports = __webpack_public_path__ + "img/build-tile-replacement.dedcc3c7.jpg";